import {
  SetAllPaymentItemsAction,
  SetPaymentItemsLoadingAction,
  DeleteInvoicePaymentListItemAction,
  SetPaymentHistoryAction,
  SetPaymentHistoryLoadingAction
} from './invoice-line.actions';
import { createReducer } from '@common/redux-utils';
import { InvoicePaymentItemViewModel, InvoicePaymentHistoryViewModel } from '@models/InvoicePaymentItem';
import {
  SetSelectedInvoiceLineCvi,
  SetInvoiceLineSaveLoadingAction,
  SetInvoiceAuthorizationLinesAction,
  InvoicePaymentLineActionType
} from './invoice-line.actions';
import { SwoCviViewModel } from '@models/AuthorizationSwoCvi';
import { AuthorizationLine } from '@models/AuthorizationLine';
import { SetInvoiceAuthorizationLinesLoadingAction } from './invoice-line.actions';

export interface InvoicePaymentLineState {
  readonly items: Array<InvoicePaymentItemViewModel>;
  readonly isTableLoading: boolean;
  readonly selectedCvi?: SwoCviViewModel;
  readonly isSaving: boolean;

  readonly authoLines: AuthorizationLine[];
  readonly loadingAuthoLines: boolean;

  readonly historyList: Array<InvoicePaymentHistoryViewModel>;
  readonly historyLoading: boolean;
}

const initialInvoicePaymentListState: InvoicePaymentLineState = {
  items: [],
  isTableLoading: false,
  isSaving: false,
  authoLines: [],
  loadingAuthoLines: false,
  historyList: [],
  historyLoading: false
};

function handleSetAllPaymentItems(
  state: InvoicePaymentLineState,
  action: SetAllPaymentItemsAction
): InvoicePaymentLineState {
  return {
    ...state,
    items: action.items
  };
}

function handleSetPaymentItemsLoading(
  state: InvoicePaymentLineState,
  action: SetPaymentItemsLoadingAction
): InvoicePaymentLineState {
  return {
    ...state,
    isTableLoading: action.loading
  };
}

function handleDeleteInvoicePaymentListItem(
  state: InvoicePaymentLineState,
  action: DeleteInvoicePaymentListItemAction
) {
  if (!state.items || state.items.length === 0) {
    return state;
  }
  var itemIndex = state.items.findIndex(i => '' + i.invoiceId === '' + action.invoiceId);
  if (itemIndex === -1) {
    return state;
  }
  var newItems = state.items.slice();
  newItems.splice(itemIndex, 1);
  return {
    ...state,
    items: newItems
  };
}

function handleSetSelectedCvi(
  state: InvoicePaymentLineState,
  action: SetSelectedInvoiceLineCvi
): InvoicePaymentLineState {
  return {
    ...state,
    selectedCvi: action.cvi
  };
}

function handleSetLineItemSaveLoading(
  state: InvoicePaymentLineState,
  action: SetInvoiceLineSaveLoadingAction
): InvoicePaymentLineState {
  return {
    ...state,
    isSaving: action.loading
  };
}

function handleSetAuthorizationLines(
  state: InvoicePaymentLineState,
  action: SetInvoiceAuthorizationLinesAction
): InvoicePaymentLineState {
  return {
    ...state,
    authoLines: action.lines
  };
}

function handleSetAuthorizationLinesLoading(
  state: InvoicePaymentLineState,
  action: SetInvoiceAuthorizationLinesLoadingAction
): InvoicePaymentLineState {
  return {
    ...state,
    loadingAuthoLines: action.loading
  };
}

function handleSetPaymentHistory(
  state: InvoicePaymentLineState,
  action: SetPaymentHistoryAction
): InvoicePaymentLineState {
  return {
    ...state,
    historyList: action.items
  };
}

function handleSetPaymentHistoryLoading(
  state: InvoicePaymentLineState,
  action: SetPaymentHistoryLoadingAction
): InvoicePaymentLineState {
  return {
    ...state,
    historyLoading: action.loading
  };
}

export const InvoicePaymentItemListReducer = createReducer<InvoicePaymentLineState, InvoicePaymentLineActionType>(
  initialInvoicePaymentListState,
  {
    [InvoicePaymentLineActionType.SetAllPaymentItems]: handleSetAllPaymentItems,
    [InvoicePaymentLineActionType.SetInvoicePaymentItemsTableLoading]: handleSetPaymentItemsLoading,
    [InvoicePaymentLineActionType.DeleteInvoicePaymentListItem]: handleDeleteInvoicePaymentListItem,
    [InvoicePaymentLineActionType.SetSelectedCvi]: handleSetSelectedCvi,
    [InvoicePaymentLineActionType.SetLineItemSaveLoading]: handleSetLineItemSaveLoading,
    [InvoicePaymentLineActionType.SetAuthorizationLines]: handleSetAuthorizationLines,
    [InvoicePaymentLineActionType.SetAuthorizationLinesLoading]: handleSetAuthorizationLinesLoading,
    [InvoicePaymentLineActionType.SetPaymentHistory]: handleSetPaymentHistory,
    [InvoicePaymentLineActionType.SetPaymentHistoryLoading]: handleSetPaymentHistoryLoading
  }
);



// WEBPACK FOOTER //
// ./src/invoicing/invoice-line.reducer.tsx